import React from 'react';

import meta from '../../config/meta';

import Header from '../layout/Header.jsx';
import UserProfile from '../blocks/UserProfile.jsx';

const PageProfile = () => {
  meta.set({ title: '我的帳戶' });

  return (
    <>
      <Header
        bg={{
          cover: '/assets/img/profile_banner.png',
        }}
      >
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-md-9 col-lg-8 my-4">
              <div className="d-flex justify-content-center align-items-center wordframe">
                <img src="/assets/img/profile_title.svg" />
              </div>
            </div>
          </div>
        </div>
      </Header>
      <UserProfile />
    </>
  );
};

export default PageProfile;
